import { FC } from 'react';

import { Container } from '../../components/container';
import { IconFacebook } from '../../components/icons/facebook';
import { IconTelegram } from '../../components/icons/telegram';
import { IconTwitter } from '../../components/icons/twitter';
import { IconYoutube } from '../../components/icons/youtube';
import { IconInstagram } from '../../components/icons/instagram';
import { IconTikTok } from '../../components/icons/tiktok';
import {
  About,
  Authors,
  Copyright,
  Heading,
  Social,
  SocialLinks,
  StyledFooter,
} from './styled';
import { texts } from '../locale';
import { language } from '../locale/config';

type Props = {};

const socialConfig = [
  {
    component: IconFacebook,
    service: 'facebook',
    link: 'https://www.facebook.com/radiosvoboda.org',
  },
  {
    component: IconTelegram,
    service: 'telegram',
    link: 'https://telegram.me/svoboda_radio',
  },
  {
    component: IconTwitter,
    service: 'twitter',
    link: 'https://twitter.com/radiosvoboda',
  },
  {
    component: IconYoutube,
    service: 'youtube',
    link: 'https://www.youtube.com/channel/UC7qnYpVcuFbURi3E2E6_f6Q',
  },
  {
    component: IconInstagram,
    service: 'instagram',
    link: 'https://www.instagram.com/radio.svoboda/',
  },
  // rss: { icon: <IconRss />, newTab: false },
];
const socialConfigRu = [
  {
    component: IconTelegram,
    service: 'telegram',
    link: 'https://t.me/donbassrealii',
  },
  {
    component: IconTikTok,
    service: 'tiktok',
    link: 'https://www.tiktok.com/@donbass_realii',
  },
  {
    component: IconFacebook,
    service: 'facebook',
    link: 'https://www.facebook.com/donbassrealii',
  },
  {
    component: IconTwitter,
    service: 'twitter',
    link: 'https://twitter.com/donbassrealii',
  },
  {
    component: IconInstagram,
    service: 'instagram',
    link: 'https://www.instagram.com/donbassrealii/',
  },
];

export const Footer: FC<Props> = () => {
  return (
    <StyledFooter>
      <Container>
        <About>
          <Heading>{texts.about_1}</Heading>
          <p>{texts.about_2}</p>

          <Heading>{texts.about_3}</Heading>
          <p>{texts.about_4}</p>
          <p>{texts.about_5}</p>
        </About>
        <Authors>
          <Heading>{texts.authors_1}</Heading>
          <div>
            <div>
              <p>{texts.authors_2}</p>
              <p>{texts.authors_3}</p>
            </div>
            <div>
              <p>{texts.authors_4}</p>
              <p>{texts.authors_5}</p>
            </div>
            <div>
              <p>{texts.authors_6}</p>
              <p>{texts.authors_7}</p>
            </div>
            <div>
              <p>{texts.authors_8}</p>
              <p>{texts.authors_9}</p>
            </div>
          </div>
        </Authors>
        <Social>
          <Heading>{texts.follow_1}</Heading>
          <SocialLinks>
            {socialConfig.map((item) => (
              <li key={item.service}>
                <a href={item.link} target="_blank">
                  <item.component />
                </a>
              </li>
            ))}
          </SocialLinks>
          <Heading>{texts.follow_2}</Heading>
          <SocialLinks>
            {socialConfigRu.map((item) => (
              <li key={item.service}>
                <a href={item.link} target="_blank">
                  <item.component />
                </a>
              </li>
            ))}
          </SocialLinks>
        </Social>

        <Copyright>
          {texts.copyright_1}
          {new Date().getFullYear()}
          {texts.copyright_2}
        </Copyright>
      </Container>
    </StyledFooter>
  );
};
